module.exports = __webpack_public_path__ + "img/SKMJ_gas2.81c2d88e.jpg";